import { ref } from 'vue'
import { onHubEvent } from '@/composables/useConversationRealtime'
import { playNotificationSound } from '@/composables/useNotificationSound'

// Popup "Adiamento chegou ao limite" (SnoozeEndedModal.vue): o prazo de uma conversa adiada venceu e ela voltou pra
// Aberta. Vem do Worker pelo hub ("AdiamentoVencido", só pro grupo do agente). Fila, como o de atendimento atribuído:
// mais de uma pode vencer ao mesmo tempo.
export interface SnoozeAlert { conversationId: string; contactName: string; snoozedUntil: string }

export const pendingSnoozeAlerts = ref<SnoozeAlert[]>([])

let stopListening: (() => void) | null = null

export function startSnoozeAlerts(myAgentId: string): void {
  stopListening?.()
  stopListening = onHubEvent('AdiamentoVencido', payload => {
    const evt = payload as SnoozeAlert & { agentId: string }
    if (!evt?.conversationId || (myAgentId && evt.agentId?.toLowerCase() !== myAgentId.toLowerCase())) return
    if (pendingSnoozeAlerts.value.some(a => a.conversationId === evt.conversationId)) return
    pendingSnoozeAlerts.value.push({ conversationId: evt.conversationId, contactName: evt.contactName, snoozedUntil: evt.snoozedUntil })
    playNotificationSound()
  })
}

export function stopSnoozeAlerts(): void {
  stopListening?.()
  stopListening = null
  pendingSnoozeAlerts.value = []
}

export function dismissCurrentSnoozeAlert(): void {
  pendingSnoozeAlerts.value.shift()
}
